import type { RootState } from 'typesafe-actions';

export const getCommonError = (state: RootState) => state.commonError;

export const getIsMaintenanceMode = (state: RootState) =>
  state.commonError.commonError.httpStatusCode === 503;

export const getIsUIImplementationError = (state: RootState) =>
  state.commonError.isUIImplementationError;
